// frontend/src/utils/validation.js

export function validateVehicleForm(form) {
  const errors = {};

  if (!form.brand.trim()) {
    errors.brand = 'Marca é obrigatória';
  }
  if (!form.model.trim()) {
    errors.model = 'Modelo é obrigatório';
  }
  if (!form.version.trim()) {
    errors.version = 'Versão é obrigatória';
  }
  if (!/^\d{4}$/.test(form.year)) {
    errors.year = 'Ano deve ter 4 dígitos';
  }
  if (isNaN(form.km) || form.km < 0) {
    errors.km = 'KM inválido';
  }
  if (isNaN(form.price) || form.price <= 0) {
    errors.price = 'Preço inválido';
  }
  if (!form.description.trim()) {
    errors.description = 'Descrição é obrigatória';
  }
  if (!form.fuelType) {
    errors.fuelType = 'Selecione o combustível';
  }
  if (!form.transmission) {
    errors.transmission = 'Selecione a transmissão';
  }
  if (!form.engine.trim()) {
    errors.engine = 'Informe o motor';
  }
  if (!form.finalPlate.trim()) {
    errors.finalPlate = 'Final da placa é obrigatório';
  }
  if (isNaN(form.doors) || form.doors < 1) {
    errors.doors = 'Número de portas inválido';
  }
  if (!form.color.trim()) {
    errors.color = 'Cor é obrigatória';
  }
  if (!form.bodyType.trim()) {
    errors.bodyType = 'Tipo de carroceria é obrigatório';
  }

  if (form.fipePrice !== null && form.fipePrice !== undefined) {
    const value = Number(form.fipePrice);
    if (!Number.isFinite(value) || value < 0) {
      errors.fipePrice = 'Preco FIPE invalido';
    }
  }

  if (!['locadora', 'estoque'].includes((form.inventoryType || '').toLowerCase())) {
    errors.inventoryType = 'Selecione a origem do veiculo';
  }

  return errors;
}
